<template>
  <div
    class="
      absolute
      top-0
      left-0
      w-full
      h-full
      bg-black
      z-20
      flex flex-col
      items-center
      justify-center
      p-8
    "
  >
    <div
      class="
        flex
        items-center
        text-white text-center
        font-bold
        py-2
        px-6
        my-8
        border-2 border-white
        rounded-full
      "
    >
      Your camera and microphone are blocked
    </div>

    <p class="text-white text-center leading-relaxed">
      CE requires access to your camera and microphone.
      <br />
      Click the camera blocked icon
      <span class="p-1 bg-white rounded"><CameraPermissionBlockedIcon class="inline-flex" /></span>
      in your browser's address bar
      <br />
      to give the browser access.
      <br />
      <br />
      The page may need to be reloaded before permissions
      <br />
      take effect.
    </p>
  </div>
</template>

<script>
import { watch, computed } from 'vue';
import { useUserMedia, usePermission } from '@vueuse/core';
import useSessionStore from '@/Stores/useSessionStore';
import CameraPermissionBlockedIcon from '@/Components/Icons/CameraPermissionBlockedIcon';

export default {
  name: 'PermissionsNotGrantedOverlay',
  setup() {
    const sessionStore = useSessionStore();
    const { start } = useUserMedia();
    start();

    const microphoneAccess = usePermission('microphone');
    const cameraAccess = usePermission('camera');

    const micAndCameraAccess = computed(
      () => microphoneAccess.value == 'granted' && cameraAccess.value == 'granted',
    );

    watch(
      () => micAndCameraAccess.value,
      (accessGranted) => {
        if (accessGranted) sessionStore.hasPermissionError = false;
      },
    );

    return { microphoneAccess, cameraAccess, micAndCameraAccess };
  },
  components: {
    CameraPermissionBlockedIcon,
  },
};
</script>
